// 学员中心

export default function() {
  return [
    {
      path: '/center',
      meta: { needLogin: true },
      async beforeEnter(to, from, next) {
        document.querySelector('body').setAttribute('class', 'center')
        next()
      },
      component: () => import('../views/index'),
      children: [
        {
          path: '/center',
          meta: { needLogin: true },
          component: () => import('../views/home/index'),
          redirect: '/center/home',
          children: [
            // 学员中心主页
            {
              path: 'home',
              name: 'Home',
              meta: { needLogin: true },
              component: () => import('../views/home/home')
            },
            // 开始听课
            {
              path: 'course',
              meta: { needLogin: true },
              component: () => import('../views/course/index'),
              redirect: '/center/course/course',
              children: [
                {
                  path: 'course',
                  name: 'Course',
                  meta: { needLogin: true },
                  component: () => import('../views/course/course-v2')
                },
                // 选课
                {
                  path: 'curricula-variable',
                  name: 'CurriculaVariable',
                  meta: { needLogin: true },
                  component: () => import('../views/course/curricula-variable')
                }
              ]
            },
            // 我的试题
            {
              path: 'my-question',
              name: 'MyQuestion',
              meta: { needLogin: true },
              component: () => import('../views/my-question/my-question'),
              redirect: '/center/my-question/practice',
              children: [
                // 试题练习
                {
                  path: 'practice',
                  props: true,
                  name: 'Practice',
                  meta: { needLogin: true },
                  component: () => import('../views/my-question/practice/practice')
                },
                // 模拟考试
                {
                  path: 'mock-exam',
                  props: true,
                  meta: { needLogin: true },
                  name: 'MockExam',
                  component: () => import('../views/my-question/mock-exam/mock-exam.vue')
                },
                // 每日一练
                {
                  path: 'daily-practice',
                  props: true,
                  name: 'DailyPractice',
                  meta: { needLogin: true },
                  component: () => import('../views/my-question/daily-practice/daily-practice')
                },
                // 易错题
                {
                  path: 'error-prone',
                  props: true,
                  name: 'ErrorProne',
                  meta: { needLogin: true },
                  component: () => import('../views/my-question/error-prone/error-prone.vue')
                },
                // 错题重答
                {
                  path: 'correction',
                  props: true,
                  name: 'Correction',
                  meta: { needLogin: true },
                  component: () => import('../views/my-question/correction/correction.vue')
                },
                // 收藏做题
                {
                  path: 'favorite',
                  props: true,
                  name: 'Favorite',
                  meta: { needLogin: true },
                  component: () => import('../views/my-question/favorite/favorite.vue')
                }
              ]
            },
            // 做题记录
            {
              path: 'answer-record',
              name: 'AnswerRecord',
              meta: { needLogin: true },
              component: () => import('../views/answer-record/answer-record.vue'),
              redirect: '/center/answer-record/list',
              children: [
                {
                  path: 'list',
                  props: true,
                  name: 'RecordList',
                  meta: { needLogin: true },
                  component: () => import('../views/answer-record/record-list/record-list.vue')
                },
                // 做题记录-评估报告
                {
                  path: 'report',
                  props: true,
                  name: 'Report',
                  meta: { needLogin: true },
                  component: () => import('../views/answer-record/report/report.vue'),
                  redirect: '/center/answer-record/report/practice',
                  children: [
                    {
                      path: 'practice',
                      props: true,
                      meta: { needLogin: true },
                      name: 'report-practice',
                      component: () => import('../views/answer-record/report/report-practice.vue')
                    },
                    {
                      path: 'favorite',
                      props: true,
                      name: 'report-favorite',
                      meta: { needLogin: true },
                      component: () => import('../views/answer-record/report/report-favorite.vue')
                    },
                    {
                      path: 'mock-exam',
                      props: true,
                      meta: { needLogin: true },
                      name: 'report-mock-exam',
                      component: () => import('../views/answer-record/report/report-mock-exam.vue')
                    },
                    {
                      path: 'wrong',
                      props: true,
                      meta: { needLogin: true },
                      name: 'report-wrong',
                      component: () => import('../views/answer-record/report/report-wrong.vue')
                    }
                  ]
                }
              ]
            },
            // 订单列表
            {
              path: 'order',
              props: true,
              name: 'OrderList',
              meta: { needLogin: true },
              component: () => import('../views/order/order.vue')
            },
            // 订单详情
            {
              path: 'order-detail',
              props: true,
              name: 'OrderDetail',
              meta: { needLogin: true },
              component: () => import('../views/order/order-detail.vue')
            },
            // 个人资料
            {
              path: 'mine',
              props: true,
              name: 'Mine',
              meta: { needLogin: true },
              component: () => import('../views/mine/mine.vue')
            }
          ]
        },
        // 课程详情
        {
          path: 'course-detail/:schemeId/:learningId/:issueId/:courseId',
          name: 'CourseDetail',
          meta: { needLogin: true },
          component: () => import('../views/course-detail/course-detail')
        }
      ]
    }
  ]
}
